import ReactGA from 'react-ga4'
import { getApps } from 'firebase/app';
import { isSupported, getAnalytics, type Analytics } from 'firebase/analytics';

import { FIREBASE_MEASUREMENT_ID } from 'src/config-global';

let analytics: Analytics | null = null;

export const initAnalytics = async (cpf: string): Promise<Analytics | null> => {
  if (typeof window === 'undefined') return null;

  if (!(await isSupported().catch(() => false))) return null;

  if (!getApps().length) {
    ReactGA.initialize([
      {
        trackingId: FIREBASE_MEASUREMENT_ID,
        gaOptions: {
          userId: btoa(cpf),
        },
      },
    ]);
  }
  if (!analytics) {
    analytics = getAnalytics();
  }
  return analytics;
};

export const setAnalyticsUserId = async (cpf: string) => {
  if (!cpf) return;
  await initAnalytics(cpf);
};


export function getClientId() {
  const gaCookie = document.cookie.split('; ').find((row) => row.startsWith('_ga='));
  if (!gaCookie) return undefined;
  const gaValue = gaCookie.split('=')[1];
  const parts = gaValue.split('.');
  return parts.length >= 4 ? `${parts[2]}.${parts[3]}` : undefined;
}
